import {AccessLevels, ContainerNamespace} from '@/types/containers';

export const NAMESPACE_PORTFOLIO = 'portfolio';
export const NAMESPACE_MONITORING = 'search-alert';

export const ACCESS_LEVEL_NAMES = {
  [AccessLevels.VIEW_ONLY]: 'accessLevel.container_view_only',
  [AccessLevels.READ_ONLY]: 'accessLevel.container_read_only',
  [AccessLevels.READ_WRITE]: 'accessLevel.container_read_write',
  [AccessLevels.EXTENDED]: 'accessLevel.container_extended',
  [AccessLevels.OWNED]: 'accessLevel.container_owned'
} as const;

export const NAMESPACE_NAMES = {
  [ContainerNamespace.NAMESPACE_PORTFOLIO]: 'container.portfolio',
  [ContainerNamespace.NAMESPACE_MONITORING]: 'container.monitoring',
} as const;
